import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/55d8a1fb/src/components/layout.js";
import Layout from "../../../components/layout";
import { Link } from "gatsby";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Rent Control`}</h1>
    <p>{`What is the difference between rent control and this new legislation?`}</p>
    <p>{`Rent Control locks the increase in rent to the cost of living, and only can increase a couple percent every year.`}</p>
    <p>{`To qualify for rent control, an apartment must`}</p>
    <ul>
      <li parentName="ul">{`Rules`}</li>
      <li parentName="ul">{`go`}</li>
      <li parentName="ul">{`here`}</li>
    </ul>
    <p>{`Based on this information, do you have rent control?`}</p>
    <Link to="/counties" mdxType="Link">I do, help me find renter's resources in my area</Link>
    <Link to="/coverage/age-check" mdxType="Link">I'm not covered</Link>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      